import React from 'react';
import { useIntl } from 'react-intl';

import { ErrorMessage } from 'formik';
import TextField from '@material-ui/core/TextField';

import { DESCRIPTION_ROWS_COUNT } from '../../../CustomerSupportConstants';

import './CandidateCustomerSupportRequestForm.scss';

const CustomerSupportFormView = ({
    values,
    handleChange,
    errors,
    touched,
}) => {
    const intl = useIntl();

    return (
        <form className="candidate-customer-support-request-form" autoComplete="off">
            <div className="candidate-customer-support-request-field">
                <TextField
                    fullWidth
                    variant="outlined"
                    name="name"
                    label={intl.formatMessage({ id: "name" })}
                    value={values.name}
                    onChange={handleChange}
                    error={errors.name && touched.name}
                />
                <ErrorMessage name="name" component="div" className="invalid-field-message" />
            </div>

            <div className="candidate-customer-support-request-field description">
                <TextField
                    multiline
                    fullWidth
                    variant="outlined"
                    name="description"
                    label={intl.formatMessage({ id: "describe-your-problem" })}
                    value={values.description}
                    onChange={handleChange}
                    error={errors.description && touched.description}
                    minRows={DESCRIPTION_ROWS_COUNT}
                />
                <ErrorMessage name="description" component="div" className="invalid-field-message" />
            </div>
        </form>
    );
};

export default CustomerSupportFormView;
